// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3e581346","644":"d875fa92"}[chunkId] + ".chunk.js";
};